import React, { FunctionComponent } from 'react'
import { has } from 'lodash'
import { ContentfulRichTextGatsbyReference } from 'gatsby-source-contentful/rich-text'

import Recipe from 'components/recipe'

import { RTFBlockComponentProps, RTFBlockComponentExport } from '../../types'

export interface RTFContentfulRecipeGraphQLResult
  extends ContentfulRichTextGatsbyReference {
  __typename: EF.RTFBlockTypename.ContentfulRecipe
  image: EF.FluidImageNode
  title: string
  preparationTimeMin: number
  calories: number
  ingredients: string[]
  instructionList: EF.RTFRawQueryResponse
}

export interface ContentfulRecipeBlockProps extends RTFBlockComponentProps {
  image: EF.FluidImageNode
  title: string
  preparationTimeMin: number
  calories: number
  ingredients: string[]
  instructionList: EF.RTFRawQueryResponse
}

const ContentfulRecipeBlock: FunctionComponent<ContentfulRecipeBlockProps> = ({
  image,
  title,
  preparationTimeMin,
  calories,
  ingredients,
  instructionList,
}) => {
  return (
    <Recipe
      image={image}
      title={title}
      preparationTimeMin={preparationTimeMin}
      calories={calories}
      ingredients={ingredients}
      instructions={instructionList}
    />
  )
}

const componentExport: RTFBlockComponentExport = {
  component: ContentfulRecipeBlock,
  isValid: ({ title, ingredients, instructionList }) =>
    !!title && !!ingredients && has(instructionList, 'raw'),
}

export default componentExport
